// /guide/beginner-guide/about-pist6/ で使用

import { Swiper, Navigation } from 'swiper/core';
Swiper.use([Navigation]);

export default () => {

  const b = {};
  const init = () => {
    b.root = document.querySelector('.gu-banner');
    if (!b.root) {
      return;
    }
    console.log('build gu-banner', b.root);

    buildSwiper();
  }

  const isPC = window.matchMedia('(min-width: 768px)').matches;
  const pcSlideWidth = 320;
  const spSlideWidth = 150;
  const swiperOption = {
    width: calcWidthLength(isPC ? pcSlideWidth : spSlideWidth),
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 2,
  };

  const buildSwiper = () => {
    b.container = b.root.querySelector('.gu-banner__container');
    const nextBtn = b.root.querySelector('.gu-banner__btn._next')
    const prevBtn = b.root.querySelector('.gu-banner__btn._prev')
    swiperOption.navigation = {
      nextEl: nextBtn,
      prevEl: prevBtn
    }
    b.swiper = new Swiper(b.container, swiperOption);
    window.addEventListener('resize', resize);
  }

  let timerId = null;
  const resize = () => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      b.swiper.destroy(true, true);
      swiperOption.width = calcWidthLength(isPC ? pcSlideWidth : spSlideWidth);
      b.swiper = new Swiper(b.container, swiperOption);
      timerId = null;
    }, 0);
  }

  function calcWidthLength (num) {
    const ww = window.innerWidth;
    // 1rem の pixel 計算
    let ROOTREM = 0;
    if (ww > 1280) {
      ROOTREM = 10 + 2 * (ww - 1280) / 400;
    } else if (ww >= 768) {
      ROOTREM = ww * .78125 / 100;
    } else {
      ROOTREM = 10 + 8 * (ww - 375) / 649;
    }
    return (num * ROOTREM / 10) | 0;
  }

  init();
}
